module.exports = __webpack_public_path__ + "media/images/number_4_red-c6af199506b8878fa5e1c1c4d9386d6a.png";